module.exports = __webpack_public_path__ + "assets/img/windows.d04f5967.svg";